<template>
  <v-list nav dense>
    <template>
      <v-list-item link router to="/home" class="list" active-class="white black--text">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('inicio') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-group prepend-icon="mdi-golf" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Golf</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/golf/scorecards" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-chart-line</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_scorecards') || 'Scorecards' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/handicaps" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-calculator</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_handicaps') || 'Handicaps' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/players-summary" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-account-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_players_summary') || 'Resumen de Jugadores' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/reservations" class="list" active-class="white black--text">
                    <v-list-item-action>
                        <v-icon>mdi-calendar-clock</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ $t('golf_reservations') }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
      </v-list-group>

              <v-list-item link router to="/golf/tournaments" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-tournament</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ $t('golf_tournaments') || 'Torneos' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      <v-list-group prepend-icon="mdi-handshake" no-action color="white">
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>Convenios de Golf</v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item link router to="/golf/convenios" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-plus-circle</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Generar Nuevo Convenio
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/convenios/listado" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-list-box</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Listado de Convenios
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/convenios/tipos" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-tag-multiple</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Tipos de Convenios
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link router to="/golf/convenios/campos" class="list" active-class="white black--text">
          <v-list-item-action>
            <v-icon>mdi-golf</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Campos Disponibles
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
    </template>
  </v-list>
</template>

<script>
export default {
  name: 'golf_public_relations'
}
</script>
